import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
// import { TraceUpdateComponent } from 'app/views/appviews/trace-update/trace-update.component';
// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {Location} from '@angular/common';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay, map } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';

import { Brand } from './../../../api/brand';
import { BsModalRef, BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { CompanyEditComponent } from '../company-edit/company-edit.component';
import { MyobApiCustomerClientSyncToolsWidgetComponent } from 'src/app/components/myob/myob-api-customer-client-sync-tools-widget/myob-api-customer-client-sync-tools-widget.component';


@Component({
  selector: 'app-company-view',
  templateUrl: './company-view.component.html',
  styleUrls: ['./company-view.component.css']
})
export class CompanyViewComponent implements OnInit {
  brand: any;
  @Input() brand_id: any;
  brandUsers: any;
  brandUsersCount: any;
  brand_type: any;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  // Switches for show hide things
  addTraceCandidate = false;
  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  baseUploadURL: string;
  nav: any;
  // end tabs


  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  user_level: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  metric_qualification_renewal_date: Date;
  today_format: Date;
  agent_qualification_status_expired: any = 0;
  brand_type_id: any;
  company_global_key_data: any;
  company_global_key: any;
  myobCustomers: Object;
  arrCase: object[];
  Items: any;
  sent_data: any;
  baseMyobCustomers: any;
  comparitor_array: any;
  comparitor_array_B: any;
  myob_id: any;
  company_name: any;
  myobSuppliers: Object;
  company_ABN: any;
brand_client_code_: any;
brand_client_code_ALL: any;


  constructor(
    private http: HttpClient, private router: Router, private route: ActivatedRoute, private _demoService: DemoService,
    public datepipe: DatePipe, private _location: Location,
    private modalService: BsModalService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    public gfunc: GlobalFunctionsService,
    public myobApi_CTW: MyobApiCustomerClientSyncToolsWidgetComponent,
  ) {

    // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

    this.nav = document.querySelector('nav.navbar');

    this.nav.className += ' white-bg';
    this.brand_id = +this.route.snapshot.paramMap.get('brand_id');
    this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.brand_id; // no trailing slash


    this.gfunc.myobChecker(); // so many functions and checks load this first.

   }

  ngOnInit() {
 

    this.getBrandById(this.brand_id);
    this.getBrandUsers(this.brand_id);
    this.getBrandJobsTableData(this.brand_id);


    // Grid Options
    this.toolbarOptions = ['ExcelExport', 'Search', 'PdfExport'];
    this.initialPage = { pageSize: 20 };
    this.filterOptions = {
       type: 'Menu'
    };
   this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
    this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };
    this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };


// end date filter options
    // End Grid Options
  }


  getBrandById(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      data => { this.brand = data;
  
       let res = data[0];


// agent qualification cheker
console.log('Agent Qualification Renewal Date: ', data[0].qualification_renewal_date);

// this.metric_qualification_renewal_date = new Date(this.brand[0].qualification_renewal_date * 1000);
this.metric_qualification_renewal_date = new Date(this.brand[0].qualification_renewal_date);
// this.metric_qualification_renewal_date = data[0].qualification_renewal_date;
this.today_format = new Date(this.gfunc.today);

if (res.brand_type_id == 3){
if (this.metric_qualification_renewal_date <= this.today_format) {
  console.log('NOTICE: This agent qualification has expired');
  this.agent_qualification_status_expired = 1;
}
}

this.brand_type_id = res.brand_type_id;
this.myob_id =res.myob_id;
this.company_name =res.name;
this.company_ABN = res.abn;

       this.getBrandType(res.brand_type_id);


      //  this.gfunc.myobChecker()
       if (this.brand_type_id == 2){
        this.getMyobCustomers() // Filter for Same UID and Company Name.
      }
      
      if (this.brand_type_id == 3){
        this.getMyobSuppliers() // Filter for Same UID and Company Name.
      }
      


     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );

  }






  // uses demo services but calls to myob
  public getMyobSuppliers() {
    this._demoService.getMyobSuppliers().subscribe(
      data => { this.myobSuppliers = data;
        const res = data[0];
         // https://www.concretepage.com/questions/577
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
  this.Items = data['Items'] ;
  this.sent_data = this.Items;

          // Filters
          const ClientsFiltered = Object(this.sent_data).filter((ac) => (ac.UID === this.myob_id || ac.CompanyName === this.company_name )); 
          this.sent_data = ClientsFiltered;

       

         console.log(this.Items);
        // this.Address = this.Items['Address'];
  // return this.myobCustomers;

  // Map the data top the new model system
 // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));

      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading Trace Types')
    );

  };




  getBrandUsers(brand_id) {
    this._demoService.getBrandUsers(brand_id)
      .subscribe(
        data => { this.brandUsers = data;
        this.brandUsersCount = this.brandUsers.length;
        let res = data[0];
        this.getFormUserLevel(res.access_level);
        },
        err => console.error(err),
       //  () =>  console.log('loading L')
      );
  }

  getBrandType(brand_type_id) {
    this._demoService.getBrandBrandType(brand_type_id).subscribe(
       data => { this.brand_type = data; },
       
       err => console.error(err),
       () => console.log('done loading brand_types')
     );
   }



  
  getFormUserLevel(level) {
    this._demoService.getUserLevel(level).subscribe(
       data => { this.user_level = data;
       // console.log(data);
     },
       err => console.log(err.error),
      // () => console.log('done loading User Levels')
     );
   }


  // modal
  
   // MODAL
  // start of modal windows service as a template
   // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    // small upgrade to disable background click on open modal background
    const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
    this.modalRef = this.modalService.show(template, config);
  }
  
  // :: Parent / Child modal test
  closeParentModel() {
    // alert('parent component function.');
    this.modalRef.hide();
    this.getBrandById(this.brand_id);
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  };



  // MODAL view a component
  openModalEditCompanyComponent(brand_id) {
    const initialState = {
      list: [
        'Open a modal with component',
        'Pass your data',
        'Do something else',
        '...'
      ],
      title: 'Modal with component',
      trace_id: 1010,
      brand_id: brand_id
    };
    this.bsModalRef = this.modalService.show(CompanyEditComponent, {initialState});
    this.bsModalRef.content.closeBtnName = 'Close';
  }



/// TABS
selectTab(tab_id: number) {
  this.staticTabs.tabs[tab_id].active = true;
};


   // to router navigate back
public goBack() {
  this._location.back();
}



// Setup the SyncFusion GRID


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}



brandView(brand_id) {
  // this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
  this.gfunc.globalBrandView(brand_id);
}

brandEdit(brand_id) {
  // this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
  this.gfunc.globalbrandEdit(brand_id);
}


jobLink(job_id) {
  // this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  this.gfunc.globalJobEditStep3(job_id);
}

jobView(job_id) {
  // this.router.navigate(['/admin/jobs/view/' + job_id + '']);
   this.gfunc.globalJobView(job_id);
}

subjectEdit(subject_id){
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  this.gfunc.globalJobSubjectView(subject_id);
}



refreshGrid(){ // refresh the databutton
  //this.mapJobTableLive();
  this.getBrandJobsTableData(this.brand_id);
  this.grid.refresh();
};





getBrandJobsTableData(brand_id) {
  this._demoService.getBrandJobsTableData(brand_id).subscribe(
    data => { this.subjects_urgent = data;
      this.open_jobs_count = this.subjects_urgent.length;
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.subjects_urgent = DataUtil.parse.parseJson(data); 
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    // return Observable.throw(error);
    }
  ); }


// End Grid Items and Setup


userView(user_id) {
  // this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
  this.gfunc.globalUserView(user_id);
}

userEdit(user_id) {
  // this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
  this.gfunc.globalUserEdit(user_id);
}






getBrandPasswordKeyHash(model) {
  this._demoService.getBrandPasswordKeyHash(model)
  .pipe(
    this.toastr.observe({
       loading: '... decrypting key',
       success: '🚀 ... Showing Password',
       error: '😡'
    })
  )
  .subscribe(
    data => { 
      this.company_global_key_data = data;
      this.company_global_key = this.company_global_key_data.global_company_key
    
    },
    err => console.error(err),
    () => console.log('done loading company')
  );
}



// copy to clipbard button
// ::@ https://stackoverflow.com/questions/49102724/angular-5-copy-to-clipboard
copyMessage(val: string){
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  this.toastr.success(val + '');
}






  // uses demo services but calls to myob
  public getMyobCustomers() {
    this.gfunc.myobChecker();
    return  this._demoService.getMyobCustomers().subscribe(
        data => { this.myobCustomers = data;
          const res = data[0];
           // https://www.concretepage.com/questions/577
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.Items = data['Items'] ;
           this.sent_data = this.Items;
          // this.toastr.info('Myob Datas Gathered')
           // console.log(this.Items);
          // this.Address = this.Items['Address'];
    // return this.myobCustomers;
  
    // this.comparitor_array = [];
    // this.baseMyobCustomers.items = DataUtil.parse.parseJson(data); 
    // this.baseMyobCustomers = DataUtil.parse.parseJson(data); 


        
          // Filters
          const ClientsFiltered = Object(this.sent_data).filter((ac) => (ac.UID === this.myob_id || ac.CompanyName === this.company_name )); 
          this.sent_data = ClientsFiltered;


                //     this.baseMyobCustomers =  this.Items;
                //    // console.log(JSON.stringify(this.baseMyobCustomers))
                //   //  console.log(JSON.stringify(this.Items))
                    
                //     if (!this.comparitor_array){this.comparitor_array = [];}
                //     if (!this.comparitor_array_B){this.comparitor_array_B = [];}

                //   // Count items and then push to the comparitor array with same being sent from the myob call.
                //         // let  count_of_items = Object.keys(this.baseMyobCustomers).length;
                //         let  count_of_items = this.baseMyobCustomers.length;
                //         console.log("Count of items: " + count_of_items);


                //         // // now loop and push to join model
                //         for(let i=0;i < count_of_items; i++) {
                //           let res_push = this.baseMyobCustomers[i];


                //           // -- Add a new check here to see if apart of the search_resulss "customers array" and if so then push... if not then skip the push
                //           // This should allow the search_model to filter the Results as well, then push again....



                        
                // // console.log("Tax code: " + res_push.SellingDetails.FreightTaxCode.UID)

                //             // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                //             this.comparitor_array.push({
                //               CompanyName: res_push.CompanyName,
                //               UID: res_push.UID,
                //               RowVersion: res_push.RowVersion,
                //               TaxCode: res_push.SellingDetails.TaxCode.UID,
                //               FreightTaxCode: res_push.SellingDetails.FreightTaxCode.UID,
                //               // TaxCode: res_push.SellingDetails,
                //               // FreightTaxCode: '',
                //               brand_id: res_push.DisplayID,
                //               name: '',
                //               via: 'MYOB',
                //               real_brand_id: null,
                //               LastModified: res_push.LastModified

                //                     });

                //             this.comparitor_array_B.push({
                //               CompanyName: res_push.CompanyName,
                //               UID: res_push.UID,
                //               RowVersion: res_push.RowVersion,
                //               TaxCode: res_push.SellingDetails.TaxCode.UID,
                //               FreightTaxCode: res_push.SellingDetails.FreightTaxCode.UID,
                //               // TaxCode: res_push.SellingDetails,
                //               // FreightTaxCode: '',
                //               brand_id: res_push.DisplayID,
                //               name: '',
                //               via: 'MYOB',
                //               real_brand_id: null,
                //               LastModified: res_push.LastModified
                //                     });       
                        
                //         } // end brands loop.
                //        this.comparitor_array =  this.comparitor_array;
                //       //  this.comparitor_grid.refresh(); // refreshes this grid
                //        this.grid.refresh(); // refreshes this grid
                //       //  this.toastr.success("Myob customers pushed to comparitor array");




    // Map the data top the new model system
   // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );
  
    }


    // :: This function Updtes local brand with the latest company details from MYOB. via an umnmatched myob ID and row versions - usially match by name/CustomerName
    // :: FUnction working but not updating all fields... moving on as it does enought to work an dfunction 12/2/24
pullBrandMobVersions(sent_data, model){
    // Just update the nessisary things...


  // this.brand[0].RowVersion = sent_data.RowVersion + '-MEEEEE';

  let new_model = {

    ...model[0],
    ...this.brand[0],

      RowVersion: sent_data?.RowVersion,
      myob_id: sent_data?.UID,
      UID: sent_data?.UID,
      TaxCode: sent_data?.TaxCode,
      FreightTaxCode: sent_data?.FreightTaxCode,
      updated_by: this.gfunc.sessionUserId,
      updated: this.gfunc.today,
      //
      IsIndividual: sent_data?.IsIndividual,
      SaleLayout: sent_data?.IsIndividual,
      InvoiceDelivery: sent_data?.InvoiceDelivery,
      myob_customer_array: sent_data,
      brand_id: this.brand_id,
      abn: sent_data?.SellingDetails?.ABN

   
  }


  /*

  		$stmt->bindParam(':sync_with_myob', $sync_with_myob);
		$stmt->bindParam(':myob_id', $myob_id);
		$stmt->bindParam(':IsIndividual', $IsIndividual);
		$stmt->bindParam(':SaleLayout', $SaleLayout);
		$stmt->bindParam(':InvoiceDelivery', $InvoiceDelivery);
		$stmt->bindParam(':TaxCode', $TaxCode);
		$stmt->bindParam(':FreightTaxCode', $FreightTaxCode);
		$stmt->bindParam(':RowVersion', $RowVersion);
			$stmt->bindParam(':updated', $updated);
		$stmt->bindParam(':myob_customer_array', $myob_customer_array);
  */

  // console.log(JSON.stringify(new_model));

    this._demoService.updateBrand(new_model).subscribe(
        data => {  // this.trace_candidate_update = data;
          // refresh the list
         // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        this.toastr.success('Company Updated with New Myob Versions');
        this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
      
        this.gfunc.globalBrandViewSkipRoute(this.brand_id);
          // reload the brand.

        },
        error => {
         // console.error('Error saving Event!');
          this.toastr.error('Error Updating Brand');
         return console.log(error);
        }
       // err => console.error(err),
       // () => console.log('done updates')
    );
}






pullSupplierBrandMobVersions(sent_data, model){
  // Just update the nessisary things...


// this.brand[0].RowVersion = sent_data.RowVersion + '-MEEEEE';

let new_model = {

  ...model[0],
  ...this.brand[0],

    RowVersion: sent_data.RowVersion,
    myob_id: sent_data.UID,
    UID: sent_data.UID,
    TaxCode: sent_data.TaxCode,
    FreightTaxCode: sent_data.FreightTaxCode,
    updated_by: this.gfunc.sessionUserId,
    updated: this.gfunc.today,
    //
    IsIndividual: sent_data.IsIndividual,
    SaleLayout: sent_data.IsIndividual,

    myob_customer_array: sent_data,
    brand_id: this.brand_id,
    BuyingDetails: sent_data.BuyingDetails,
    PaymentDetails: sent_data.PaymentDetails,
    abn: sent_data.BuyingDetails.ABN

 
}

// --- look at what I am updating with a work orderBy.... FIeleds...



/*

    $stmt->bindParam(':sync_with_myob', $sync_with_myob);
  $stmt->bindParam(':myob_id', $myob_id);
  $stmt->bindParam(':IsIndividual', $IsIndividual);
  $stmt->bindParam(':SaleLayout', $SaleLayout);
  $stmt->bindParam(':InvoiceDelivery', $InvoiceDelivery);
  $stmt->bindParam(':TaxCode', $TaxCode);
  $stmt->bindParam(':FreightTaxCode', $FreightTaxCode);
  $stmt->bindParam(':RowVersion', $RowVersion);
    $stmt->bindParam(':updated', $updated);
  $stmt->bindParam(':myob_customer_array', $myob_customer_array);
*/

// console.log(JSON.stringify(new_model));

  this._demoService.updateBrand(new_model).subscribe(
      data => {  // this.trace_candidate_update = data;
        // refresh the list
       // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
      this.toastr.success('Company Supplier Updated with New Myob Versions');
      this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
    
      // this.gfunc.globalBrandViewSkipRoute(this.brand_id);
        // reload the brand.

      },
      error => {
       // console.error('Error saving Event!');
        this.toastr.error('Error Updating Brand');
       return console.log(error);
      }
     // err => console.error(err),
     // () => console.log('done updates')
  );
}



removeLocalBrandMobVersions(model){
  // Just update the nessisary things...
let new_model = {
    ...model,
    ...this.brand[0], // or model[0]
    RovVersion: null,
    myob_id: null,
    UID: null,
    TaxCode: null,
    FreightTaxCode: null,
    updated_by: this.gfunc.sessionUserId,
    updated_date: this.gfunc.today,

}


// console.log(JSON.stringify(new_model));

this._demoService.updateBrand(new_model).subscribe(
    data => {  // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    this.toastr.success('Company Updated/Cleared Myob Versions');
    this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
  
  //  this.gfunc.globalBrandViewSkipRoute(this.brand_id);
      // reload the brand.

    },
    error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Updating Brand');
     return console.log(error);
    }
   // err => console.error(err),
   // () => console.log('done updates')
);
}







fixLocalBrandTaxCodesMobVersions(model){
  // Just update the nessisary things...
let new_model = {
    ...model,
    ...this.brand[0], // or model[0]
    TaxCode: this.gfunc.myob_TaxCode,
    FreightTaxCode: this.gfunc.myob_FreightTaxCode,
    updated_by: this.gfunc.sessionUserId,
    updated_date: this.gfunc.today,

}


// console.log(JSON.stringify(new_model));

this._demoService.updateBrand(new_model).subscribe(
    data => {  // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    this.toastr.success('Company Tax Codes Updated.');
    this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
  
  //  this.gfunc.globalBrandViewSkipRoute(this.brand_id);
      // reload the brand.

    },
    error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Updating Brand Tax Coodes');
     return console.log(error);
    }
   // err => console.error(err),
   // () => console.log('done updates')
);
}


// Run log 87 send welcome email  Blk
sendUserWelcomeEmailBulk(): void {
  if (confirm('Are you sure you wish to send welcome emails to All active users of this company? ')) {

  if (!this.brandUsers || !Array.isArray(this.brandUsers)) {
    console.error('No users loaded to process');
    return;
  }

  this.brandUsers.forEach(user => {
    if (user.is_active) {
      const model: any = {
        last_insert_id: user.user_id,
        brand_report_user_id: user.user_id,
        custom_run: 'user_welcome_email',
        created_by: this.gfunc.sessionUserId,
        ...user // full user model.
      };

      this.gfunc.insertLog_CreateUserSendWelcomeEmail(model);
    }
  });

    this.toastr.success('Company Users Wecome Email Sent');
  }
}


// noved to globals

//       createBrandClientCode(brand_id){
//          this._demoService.createBrandClientCode(brand_id).subscribe(
//               data => {  this.brand_client_code_ = data; // this is the retuned json upon creation.
//           this.toastr.success('Company Client Code Created.' + this.brand_client_code_);
             
//               },
//               error => {
//                 this.toastr.error('There was an issue creating the cleint code.!');
//                 console.log(error);
//                                // return Observable.throw(error);
//               }
//          );
//   }



// createBrandClientCodesAll(){
//            this._demoService.createBrandClientCodesAll().subscribe(
//               data => {  this.brand_client_code_ALL = data; // this is the retuned json upon creation.
//           this.toastr.success('All Company Client Codes Created.');
             
//               },
//               error => {
//                 this.toastr.error('There was an issue creating the client codes.!');
//                 console.log(error);
//                                // return Observable.throw(error);
//               }
//          );
// }





}


